export default __webpack_public_path__ + "static/media/section2_7_1.15083def.png";